import { motion, useReducedMotion } from "framer-motion";

const STATS = [
    { label: "Reaktionszeit", value: "< 24h" },
    { label: "Einsatzgebiet", value: "Innsbruck & Tirol" },
    { label: "Fokus", value: "Privat + Gewerbe" },
    { label: "Service", value: "Persönlich" },
];

export default function Stats() {
    const reduce = useReducedMotion();
    return (
        <section
            data-testid="trust-stats"
            className="relative py-14 sm:py-16 lg:py-20"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="rounded-3xl border border-[rgba(185,194,207,0.18)] bg-[rgba(14,20,31,0.75)] backdrop-blur-md p-6 sm:p-8 lg:p-10 card-elevated">
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
                        {STATS.map((s, i) => (
                            <motion.div
                                key={s.label}
                                initial={reduce ? false : { opacity: 0, y: 14 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-40px" }}
                                transition={{ duration: 0.4, delay: i * 0.05 }}
                                className="flex flex-col gap-1"
                            >
                                <p className="text-xs font-mono uppercase tracking-[0.18em] text-[#7BD3FF]">
                                    {s.label}
                                </p>
                                <p className="font-heading text-2xl sm:text-3xl font-semibold text-white">
                                    {s.value}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
